import Input, { type InputFieldProps } from '../../../components/fields/InputField';
import { InputContainer } from './shared';

const InputField = (props: InputFieldProps) => (
    <InputContainer>
        <Input {...props} />
    </InputContainer>
);

export default InputField;
